export default __webpack_public_path__ + "static/media/circles2.b29abfdb.png";